import { useEffect } from 'react';

import { isInApp } from '../../main/util/is-app';
import { useToast } from '../../shared/hooks/use-toast';
import { getStorageValue, setStorageValue } from '../../shared/utils/storage';
import { CookieBanner } from '../components/cookie-banner/cookie-banner';

const COOKIE_STORAGE_KEY = 'cookies-accepted';

export function useCookieBanner() {
    const toast = useToast();
    const isNativeApp = isInApp();
    useEffect(() => {
        const isAccepted = getStorageValue<boolean>(COOKIE_STORAGE_KEY);

        if (isAccepted || isNativeApp) {
            return;
        }

        const id = toast(
            ({ id }) => (
                <CookieBanner
                    onAccept={() => {
                        toast.dismiss(id);
                        setStorageValue(COOKIE_STORAGE_KEY, true);
                    }}
                />
            ),
            {
                duration: Infinity,
            },
        );

        return () => {
            toast.dismiss(id);
        };
    }, [toast]);
}
